import { Node } from '@tiptap/core';

// Rule priority, not extension priority: ProseMirror tries every mark rule before
// any node rule at equal rule priority, so a locked span would be read as a textStyle.
const RULE_PRIORITY = 200;

export const RAW_BLOCK_TAGS = ['table', 'pre', 'iframe', 'video', 'figure', 'center'];
export const RAW_INLINE_SELECTORS = ['img', 'span[data-dynamic-locked]', 'button', 'svg', 'sup', 'sub', 'small'];
export const RAW_ISLAND_SELECTOR = [...RAW_BLOCK_TAGS, ...RAW_INLINE_SELECTORS].join(', ');

// Markup the schema cannot model is kept as an atom holding its outerHTML, so it
// serialises back byte for byte. PM marks atoms contenteditable=false in its own
// view only; the saved HTML never carries it.
const rawHtmlAttribute = {
	html: { default: '', rendered: false },
};

const readOuterHtml = (dom: HTMLElement | string) => ({
	html: typeof dom === 'string' ? '' : dom.outerHTML,
});

function renderRaw(html: string) {
	const container = document.createElement('div');
	container.innerHTML = html;
	return { dom: container.firstElementChild ?? document.createElement('span') };
}

export const RawBlock = Node.create({
	name: 'rawBlock',
	group: 'block',
	atom: true,
	selectable: true,
	draggable: false,
	addAttributes: () => rawHtmlAttribute,
	parseHTML: () => RAW_BLOCK_TAGS.map(tag => ({ tag, priority: RULE_PRIORITY, getAttrs: readOuterHtml })),
	renderHTML: ({ node }) => renderRaw(node.attrs.html),
});

export const RawInline = Node.create({
	name: 'rawInline',
	group: 'inline',
	inline: true,
	atom: true,
	selectable: true,
	draggable: false,
	addAttributes: () => rawHtmlAttribute,
	parseHTML: () => RAW_INLINE_SELECTORS.map(tag => ({ tag, priority: RULE_PRIORITY, getAttrs: readOuterHtml })),
	renderHTML: ({ node }) => renderRaw(node.attrs.html),
});
